// removed by extract-text-webpack-plugin
module.exports = {"wrapper-welcome":"magazines_6Yrfw","wrapper-welcome__content":"magazines_2A4pY","wrapper-welcome__content-illustration":"magazines_2i5vh"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Welcome/styles.scss
// module id = 1268
// module chunks = 1